import { useStore } from 'zustand';
import { identity } from 'ramda';
import type { PDPStore } from './store';
import { usePDPDependency } from '@/scopes/products/infrastructure/dependencies';

export const usePDPStore = () => {
  const store = usePDPDependency('pdpStore');
  return useStore(store, identity<PDPStore>);
};

export const usePDPSelector = <T>(selector: (state: PDPStore) => T): T => {
  const store = usePDPStore();
  return selector(store);
};
